import { Message } from 'types';

const API_MESSAGES: { [key: string]: Message } = {
  '403-SS-USER-STORE_PERMISSION': {
    value: 'O usuário não tem permissão na loja [store]',
    type: 'error',
  },
  '404-SS-REVOKE_REASON-NOT_FOUND': {
    value: 'Motivo de recusa [reason] não encontrada',
    type: 'error',
  },
  '404-SS-DELIVERY_MODE-NOT_FOUND': {
    value: 'Transportadoras [deliveryModes] não encontradas',
    type: 'error',
  },
  '404-SS-SALES_MODE-NOT_FOUND': {
    value: 'Modalidade [salesModes] não encontrada',
    type: 'error',
  },
  '404-SS-CONSIGNMENT-NOT_FOUND': {
    value: 'Remessa [consignment] não encontrada',
    type: 'error',
  },
  '404-SS-STORE-NOT_FOUND': {
    value: 'Loja [store] não encontrada',
    type: 'error',
  },
  '404-SS-POINT_OF_SALE-NOT_FOUND': {
    value: 'O ponto de venda [pointOfSale] não foi encontrado',
    type: 'error',
  },
  '404-SS-STATUS-NOT_FOUND': {
    value: 'Status da Remessa [statuses] não encontrado',
    type: 'error',
  },
  '404-SS-CONSIGNMENT_HISTORY_ENTRY_TYPE-NOT_FOUND': {
    value: 'Tipo de registro [type] não encontrado',
    type: 'error',
  },
  '404-SS-CONSIGNMENT_HISTORY_ENTRY_TYPE-NOT_ALLOWED': {
    value: 'Tipo de registro [type] não permitido',
    type: 'error',
  },
  '404-SS-ACTION-NOT_FOUND': {
    value: 'Ação [action] não encontrada',
    type: 'error',
  },
  '404-SS-DELIVERY_FAIL_REASON-NOT_FOUND': {
    value: 'Motivo de falha na entrega [deliveryFailReason] não encontrada',
    type: 'error',
  },
  '412-SS-DATE-START_NOT_FOUND': {
    value: 'Data inicial não pode ser nula',
    type: 'error',
  },
  '412-SS-DATE-END_NOT_FOUND': {
    value: 'Data final não pode ser nula',
    type: 'error',
  },
  '412-SS-STATUS-NOT_FOUND': {
    value: 'Status não pode ser nulo',
    type: 'error',
  },
  '422-SS-STATUS-NOT_VALID': {
    value: 'Status [status] não é válido',
    type: 'error',
  },
  '412-SS-PASSWORD-NOT_NULL': {
    value: 'Senha não pode ser nula',
    type: 'error',
  },
  '401-SS-PASSWORD_WRONG': {
    value: 'Senha está incorreta',
    type: 'error',
  },
  '422-SS-RETURN_REQUEST-ALREADY_REFUNDED': {
    value: 'Solicitação de devolução [returnRequest] já foi estornada',
    type: 'error',
  },
  '422-SS-RETURN_REQUEST-INVALID_ACTION_FOR_REFUND': {
    value:
      'Solicitação de devolução [returnRequest] tem ação inválida para estorno',
    type: 'error',
  },
  '412-SS-PAYMENT_MODE-INVALID': {
    value: 'Modo de pagamento é inválido',
    type: 'error',
  },
  '422-SS-ORDER-WITHOUT_OMNI_CONSIGNMENT': {
    value: 'Pedido [order] não contém nenhuma remessa omni',
    type: 'error',
  },
  '502-SS-RETURN_REQUEST-REFUND_ERROR': {
    value:
      'Gateway externo retornou um erro ao estornar a solicitação de devolução [returnRequest]',
    type: 'error',
  },
  '412-SS-ACTION-NOT_NULL': {
    value: 'Ação não encontrada',
    type: 'error',
  },
  '412-SS-AT-LEAST-ONE-FILTER': {
    value: 'Pelo menos um filtro deve ser fornecido',
    type: 'error',
  },
  '404-SS-ORDER-NOT_FOUND': {
    value: 'Pedido não encontrado',
    type: 'error',
  },
  '412-SS-DELIVERY_COST-NOT_NULL': {
    value: 'Custo de entrega não pode ser nulo',
    type: 'error',
  },
  '422-SS-TYPE-NOT_VALID': {
    value: 'Tipo [type] não é válido',
    type: 'error',
  },
  '422-SS-DELIVERY_COST-INVALID_VALUE': {
    value: 'O valor informado excede o valor disponível para estorno',
    type: 'error',
  },
  '412-SS-NAME-NOT_NULL': {
    value: 'O nome não pode ser nulo',
    type: 'error',
  },
  '412-SS-CONSIGNMENT-NOT_NULL': {
    value: 'O código da remessa não pode ser nulo',
    type: 'error',
  },
  '412-SS-STORE-NOT_NULL': {
    value: 'A loja não pode ser nula',
    type: 'error',
  },
  '412-SS-DATE-INVALID_INTERVAL_TIME': {
    value:
      'O intervalo de data [interval] é maior que o permitido [intervalAllowed]',
    type: 'error',
  },
  '412-SS-DATE-START_GREATER_THAN_END': {
    value:
      'A data final [endDate] deve ser maior que a data inicial [startDate]',
    type: 'error',
  },
  '412-SS-EMAIL-INVALID': {
    value: 'E-mail [email] é inválido',
    type: 'error',
  },
  '412-SS-CONSIGNMENT_CODE-QUANTITY_ALLOWED': {
    value:
      'A quantidade de códigos de remessa [amount] excede o permitido [amountAllowed]',
    type: 'error',
  },
  '412-SS-CPF-INVALID': {
    value: 'O CPF [cpf] é inválido',
    type: 'error',
  },
  '412-SS-STORES-QUANTITY_ALLOWED': {
    value: 'A quantidade de lojas [amount] excede o permitido [amountAllowed]',
    type: 'error',
  },
  '412-SS-STORES-MUST_BE_INTEGER': {
    value: 'O nome das lojas [storeNames] deve ser numérico',
    type: 'error',
  },
  '412-SS-STORE-MUST_BE_INFORMED': {
    value: 'A loja deve ser informada para este tipo de usuário',
    type: 'error',
  },
  '412-SS-DATE-START_LESS_THAN_CURRENT': {
    value: 'Data inicial [startDate], precisa ser maior que a data atual',
    type: 'error',
  },
  '412-SS-AUTH_CODE-NOT_NULL': {
    value:
      'Para retirada feita por terceiros o código de autorização deve ser informado.',
    type: 'error',
  },
  '422-SS-AUTH_CODE-INVALID': {
    value: 'Número de Autorização inválido.',
    type: 'error',
  },
  '412-SS-CPF-MUST_BE_CUSTOMER': {
    value:
      'Para remessa de Entrega pela Loja, porém, houve a retirada pelo cliente, é necessário que seja o CPF do cliente.',
    type: 'error',
  },
  '422-SS-LAST_MODIFIED_TIME_GREATER_THAN_MAX_TIME': {
    value:
      'O período de modificação da remessa informado [currentValue] é superior ao máximo permitido [maximumValue]',
    type: 'error',
  },
  '422-SS-LAST_MODIFIED_TIME_LESS_THAN_MIN_TIME': {
    value:
      'O período de modificação da remessa informado [currentValue] é inferior ao mínimo permitido [minimumValue]',
    type: 'error',
  },
  '412-SS-PRODUCT_EANS-NOT_NULL': {
    value: 'Os Eans dos produtos não podem ser nulos',
    type: 'error',
  },
  '412-SS-REASON-NOT_NULL': {
    value: 'Motivo de recusa não pode ser nulo',
    type: 'error',
  },
  '412-SS-OBSERVATION-MORE_THAN_255': {
    value: 'A observação não pode ter mais de 255 caracteres',
    type: 'error',
  },
  '412-SS-TYPE-NOT_NULL': {
    value: 'O tipo de registro não pode ser nulo',
    type: 'error',
  },
  '412-SS-CPF-NOT_NULL': {
    value: 'O CPF não pode ser nulo',
    type: 'error',
  },
  '412-SS-DELIVERY_MODE-NOT_NULL': {
    value: 'A transportadora não pode ser nula',
    type: 'error',
  },
  '412-SS-DELIVERY_FAIL_REASON-NOT_NULL': {
    value: 'O motivo da falha na entrega não pode ser nula',
    type: 'error',
  },
  '412-SS-CPF_AND_AUTH_CODE-NOT_NULL': {
    value: 'CPF e código de autorização não podem ser nulos',
    type: 'error',
  },
  '412-SS-CPF_AND_AUTH_CODE_INVALID': {
    value: 'O código de autorização e o CPF são inválidos',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-ALREADY_RESERVED_BY_ANOTHER_STORE': {
    value: 'Remessa [consignment] está em atendimento por outra loja',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-ALREADY_RESERVED': {
    value: 'Remessa [consignment] está em atendimento por esta loja',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-NOT_AVAILABLE': {
    value: 'Remessa [consignment] não está disponível para reserva',
    type: 'error',
  },
  '422-SS-STORE-NOT_AVAILABLE': {
    value: 'Remessa [consignment] não está disponível na loja [store]',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-CONFIRMED_BY_ANOTHER_STORE': {
    value: 'Remessa [consignment] foi confirmada por outra loja',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-CONFIRMED_BY_STORE': {
    value: 'Remessa [consignment] foi confirmada por esta loja',
    type: 'error',
  },
  '422-SS-SKU-NOT_FOUND': {
    value: 'SKU inválido para o produto [product]',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-WITHOUT_RESERVED_STORE': {
    value: 'Remessa [consignment] não está em atendimento',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-NOT_IN_ATTENDANCE': {
    value: 'Remessa [consignment] não está em atendimento',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-PRODUCT-INVALID': {
    value: 'Remessa [consignment] não contém o produto [product]',
    type: 'error',
  },
  '422-SS-ACTION_INVALID-NOT_AVAILABLE': {
    value: 'Ação [action] inválida para a modalidade da remessa',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-STATUS_NOT_VALID': {
    value:
      'O status da remessa [status] não é válido para realizar o registro de coleta',
    type: 'error',
  },
  '500-SS-CONSIGNMENT-WITHOUT-PRODUCTS': {
    value: 'Remessa [consignment] não contém produtos',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-WITHOUT_CONFIRMED_STORE': {
    value: 'Remessa [consignment] não está confirmada por alguma loja',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-ALREADY_RESENT': {
    value: 'Remessa [consignment] já contém um reenvio',
    type: 'error',
  },
  '422-SS-CONSIGNMENT-SALES_MODE_NOT_VALID': {
    value:
      'Remessa [consignment] contém uma modalidade inválida para solicitar nova coleta',
    type: 'error',
  },
  '500-SS-CONSIGNMENT-INTEGRATION_FAILED_DELIVERY_COMPANY': {
    value:
      'Ocorreu um erro ao enviar a remessa [consignment] para a empresa de entrega',
    type: 'error',
  },
  '403-SS-USER-BRAND_PERMISSION': {
    value: 'Usuário não possuí acesso a marca informada',
    type: 'error',
  },
  '412-SS-CONSIGNMENT_CODE-FOUR_DIGITS': {
    value: 'Cada código [codes] deve ter pelo menos [size]',
    type: 'error',
  },
  '422-SS-NFE_NUMBER-ALREADY_USED': {
    value: 'O número da nota fiscal [nfeNumber] já foi utilizado por esta loja',
    type: 'error',
  },
  '422-SS-POINT_OF_SALE-INVALID': {
    value: 'O ponto de venda [pointOfSale] é inválido para esta loja',
    type: 'error',
  },
  '412-SS-NFE_NUMBER-NOT_NULL': {
    value: 'O número da nota fiscal não pode ser nulo',
    type: 'error',
  },
  '412-SS-NFE_NUMBER-MUST_BE_NUMERIC': {
    value: 'O número da nota fiscal deve conter apenas dígitos',
    type: 'error',
  },
  '412-SS-POINT_OF_SALE-NOT_NULL': {
    value: 'O ponto de venda não pode ser nulo',
    type: 'error',
  },
  '412-SS-OPENING_DAYS-NOT_NULL': {
    value: 'Os horários de funcionamento não podem ser nulos',
    type: 'error',
  },
  '412-SS-WEEKDAY-NOT_NULL': {
    value: 'O dia da semana não pode ser nulo',
    type: 'error',
  },
  '412-SS-OPEN-NOT_NULL': {
    value: 'O campo "Fechada" não pode ser nulo',
    type: 'error',
  },
  '412-SS-OPENING_TIME-NOT_NULL': {
    value: 'O horário de abertura não pode ser nulo',
    type: 'error',
  },
  '412-SS-CLOSING_TIME-NOT_NULL': {
    value: 'O horário de fechamento não pode ser nulo',
    type: 'error',
  },
  '412-SS-WEEKDAY-INVALID': {
    value: 'O dia da semana [weekday], é inválido',
    type: 'error',
  },
  '412-SS-TIME_RANGE-INVALID': {
    value:
      'O horário [times] está fora do limite de [initialRange] até [finalRange]',
    type: 'error',
  },
  '412-SS-CLOSING-TIME_GREATER_THAN_OPENING': {
    value:
      'O horário de fechamento [closingTimes] deve ser maior que o de abertura [openingTimes]',
    type: 'error',
  },
  '404-SS-RETURN_REQUEST_STATUS-NOT_FOUND': {
    value: 'O status de troca "[statuses]" não foi encontrado',
    type: 'error',
  },
  '412-SS-RETURN_REQUEST_CODE-FOUR_DIGITS': {
    value: 'Cada protocolo "[protocols]" deve ter pelo menos [size] dígitos',
    type: 'error',
  },
  '412-SS-RETURN_REQUEST_PROTOCOL-QUANTITY_ALLOWED': {
    value:
      'A quantidade [amount] de protocolos excede o máximo de [amountAllowed]',
    type: 'error',
  },
  '412-SS-USER_NAME-THREE_DIGITS': {
    value:
      'O nome informado "[userName]", precisa ter pelo menos [size] caracteres',
    type: 'error',
  },
  '422-SS-NO_PRODUCTS_AVAILABLE_TO_EXCHANGE': {
    value:
      'A remessa [consignment] não tem produtos disponíveis para devolução',
    type: 'error',
  },
  '412-SS-OPTION-NOT_NULL': {
    value: 'A opção tipo de entrega não pode ser nulo',
    type: 'error',
  },
  '412-SS-ENTRIES-NOT_NULL': {
    value: 'A lista de produtos para devolução não pode ser nula',
    type: 'error',
  },
  '412-SS-ENTRY_NUMBER-NOT_NULL': {
    value: 'O número do produto para devolução não pode ser nulo',
    type: 'error',
  },
  '412-SS-RETURN_REASON-NOT_NULL': {
    value: 'A razão para devolução do produto não pode ser nula',
    type: 'error',
  },
  '412-SS-QUANTITY-INVALID': {
    value: 'Quantidade [entries], de produtos para devolução é inválida',
    type: 'error',
  },
  '404-SS-RETURN_REASON-NOT_FOUND': {
    value: 'A razão [returnReasons] para devolução, não foi encontrada',
    type: 'error',
  },
  '404-SS-ENTRY-NOT_FOUND': {
    value: 'Produto "[entries]" não encontrado',
    type: 'error',
  },
  '404-SS-OPTION-NOT_FOUND': {
    value: 'A opção "[option]" não foi encontrada',
    type: 'error',
  },
  '412-SS-PROTOCOL-NOT_NULL': {
    value: 'O protocolo não pode ser nulo',
    type: 'error',
  },
  '404-SS-RETURN_REQUEST-NOT_FOUND': {
    value: 'Solicitação de devolução "[returnRequest]" não encontrada',
    type: 'error',
  },
  '422-SS-RETURN_REQUEST-CONTAINS_POST_CODE': {
    value:
      'Solicitação de devolução "[returnRequest]" contem código de postagem em tempo válido',
    type: 'error',
  },
  '422-SS-RETURN_REQUEST-STATUS_NOT_VALID': {
    value: 'O status de devolução "[status]" não é válido',
    type: 'error',
  },
  '422-SS-RETURN_REQUEST-TYPE_NOT_VALID': {
    value: 'O tipo de devolução "[type]" não é válido',
    type: 'error',
  },
  '412-SS-OBSERVATION-NOT_NULL': {
    value: 'A observação não pode ser nula',
    type: 'error',
  },
  '412-SS-NFE-NOT_NULL': {
    value: 'A chave ou o número da nota fiscal não pode ser nula',
    type: 'error',
  },
  '422-SS-EAN-INVALID': {
    value: 'O EAN [ean] não corresponde ao produto [product]',
    type: 'error',
  },
  '422-SS-NFE_KEY-INVALID_SIZE': {
    value: 'A chave da nota fiscal: [nfeKey] deve conter 44 dígitos',
    type: 'error',
  },
  '422-SS-RETURN_REQUEST-OPTIONS_COLLECT_TYPE_NOT_VALID': {
    value: 'O tipo de devolução [type], não é válido para essa ação',
    type: 'error',
  },
  '412-SS-ATTRIBUTE-NOT_NULL': {
    value: 'Todos os atributos não podem ser nulos',
    type: 'error',
  },
  '404-SS-PSP_ACCOUNT-NOT_FOUND': {
    value: 'Conta PSP não encontrada para a loja [store]',
    type: 'error',
  },
  '412-SS-PSP_REFERENCE-NOT_NULL': {
    value: 'A referencia PSP não pode ser nula',
    type: 'error',
  },
  '412-SS-DISCOUNT-NOT_NULL': {
    value: 'Desconto não pode ser nulo',
    type: 'error',
  },
  '412-SS-SEASON-NOT_NULL': {
    value: 'Estação não pode ser nula',
    type: 'error',
  },
  '412-SS-COLLECTION-NOT_NULL': {
    value: 'Coleção não pode ser nula',
    type: 'error',
  },
  '422-SS-DISCOUNT-INVALID': {
    value: 'Desconto maior que 99.99 ou menor que 0',
    type: 'error',
  },
  '412-SS-ANSWER-NOT_NULL': {
    value: 'A resposta não pode ser nula',
    type: 'error',
  },
  '412-SS-ANSWER_INVALID': {
    value: 'Resposta inválida',
    type: 'error',
  },
  '422-SS-DOCUMENT-MUST_BE_EQUALS': {
    value: 'O CNPJ da conta bancaria deve ser igual ao da loja',
    type: 'error',
  },
  '422-SS-PREFIX-MUST_BE_EQUALS': {
    value: 'O prefixo do CNPJ bancário deve ser igual ao da matriz',
    type: 'error',
  },
  '422-SS-MAX_ACTIVE_SUPER_EXPRESS_REACHED': {
    value:
      'Capacidade máxima de pedidos Super Expresso atingida. Tente novamente mais tarde.',
    type: 'error',
  },
};

const INTERNAL_MESSAGES: { [key: string]: Message } = {
  'FRONT-RE-REQUEST_TIME_OUT': {
    value: 'Por favor verifique sua conexão com a internet',
    type: 'error',
  },
  'FRONT-RE-SERVER_ERROR': {
    value: 'Falha na conexão. Erro ${}',
    type: 'error',
  },
  'FRONT-RE-LOGIN_SUCCESS': {
    value: 'Bem vindo [employeeName]!',
    type: 'success',
  },
  'FRONT-RE-NECESSARY_FIELD': {
    value: 'Campo [field] necessário',
    type: 'alert',
  },
  'FRONT-RE-CHARACTERS_LENGTH_FIELD': {
    value: 'Campo [field] deve ter pelo menos [length] caracteres',
    type: 'alert',
  },
  'FRONT-RE-LOGIN_FAILED': {
    value: 'Email ou senha inválidos	',
    type: 'error',
  },
  'FRONT-RE-REFRESH_LOG_FAILED': {
    value: 'Sessão encerrada, por favor realizar o login novamente	',
    type: 'error',
  },
  'FRONT-RE-CONSIGNMENT-ALREADY_RESERVED_ANOTHER_EMPLOYEE': {
    value: '[employeeName] já está atendendo esse pedido',
    type: 'alert',
  },
  'FRONT-RE-EAN-INVALID': {
    value: 'EAN Incorreto',
    type: 'error',
  },
  'FRONT-RE-CONSIGNMENT_SUCCESSFULLY_CONFIRMED': {
    value: 'Pedido [consignmentCode] foi confirmado com sucesso',
    type: 'success',
  },
  'FRONT-RE-SERVICE_REFUSED': {
    value: 'Atendimento do pedido [consignmentCode] foi cancelado com sucesso',
    type: 'success',
  },
  'FRONT-RE-PRODUCT_NOT_SELECTED_TO_REFUSE_CONSIGNMENT': {
    value:
      'Por favor informe ao menos um produto que gerou a desistência do atendimento',
    type: 'alert',
  },
  'FRONT-RE-CONSIGNMENT_COLLECTED': {
    value:
      'Registro de coleta do pedido [consignmentCode] realizado com sucesso',
    type: 'success',
  },
  'FRONT-RE-CONSIGNMENT_DELIVERED': {
    value: 'Pedido [consignmentCode] entregue com sucesso',
    type: 'success',
  },
  'FRONT-RE-DELIVERY_FAIL_CONFIRMED': {
    value:
      'Registro de Falha na Entrega para o pedido [consignmentCode] realizado com sucesso',
    type: 'success',
  },
  'FRONT-RE-STORE-NOT-FOUND': {
    value: 'Código de loja não encontrado',
    type: 'error',
  },
  'FRONT-RE-CLOSING-TIME-GREATER-THAN-OPEN-TIME': {
    value:
      'O horário de fechamento [closingTime] deve ser maior que o de abertura [openingTime]',
    type: 'error',
  },
  'FRONT-RE-NEW-OPENING-DAYS-UPDATED': {
    value: 'O horário de funcionamento foi alterado com sucesso',
    type: 'success',
  },
  'FRONT-RE-INVOICE_KEY_NOT_INFORMED': {
    value: 'Por favor informe o código da nota fiscal',
    type: 'alert',
  },
};

export const MESSAGES: { [key: string]: Message } = {
  ...API_MESSAGES,
  ...INTERNAL_MESSAGES,
};
